(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__cartDrawerBooted) return;
    window.__cartDrawerBooted = true;

    // Reopen-after-reload (see the pagehide listener at the bottom).
    var RESTORE_KEY = 'cart-drawer:reopen';
    var RESTORE_MAX_AGE_MS = 20000;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    // Focus may legitimately leave the panel for these while the drawer is
    // open: the scheduler's portalled date picker and the accessibility widget.
    var OUTSIDE_OK = '[data-bqos-cal-portal], .a11yw';

    function isVisible(el) {
      if (!el || !el.getClientRects().length) return false;
      return getComputedStyle(el).visibility !== 'hidden';
    }

    function readJSON(r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || '');
          err.status = r.status;
          throw err;
        }
        return data;
      });
    }

    function gated() {
      return document.body.classList.contains('bqos-gate-on');
    }

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.opener = null;
        this.navigating = false;
        this.queue = Promise.resolve();
        this.onKeydown = this.onKeydown.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
      }

      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.sectionId = this.dataset.sectionId;
        this.panel = this.querySelector('[data-cart-drawer-panel]');
        this.body = this.querySelector('[data-cart-drawer-body]');
        this.titleEl = this.querySelector('[data-cart-drawer-title]');
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('submit', this.onSubmit.bind(this));
        this.sync(this.region());
        this.restoreAfterReload();
      }

      disconnectedCallback() {
        // Theme editor re-render: never leave the page scroll-locked.
        if (this.isOpen) this.teardownOpen();
        this.bound = false;
      }

      region() {
        return this.querySelector('[data-cart-drawer-region]');
      }

      // One cart request at a time: the cart is one document server-side, and
      // overlapping /cart/*.js writes race.
      enqueue(fn) {
        var run = this.queue.then(fn, fn);
        this.queue = run.catch(function () {});
        return run;
      }

      /* ---------- open / close ---------- */

      openDrawer(opener, opts) {
        opts = opts || {};
        if (!this.isOpen) {
          this.opener = opener && opener !== document.body ? opener : null;
          this.isOpen = true;
          this.setAttribute('open', '');
          document.documentElement.classList.add('cart-drawer-locked');
          document.addEventListener('keydown', this.onKeydown);
          document.addEventListener('focusin', this.onFocusIn);
        }
        var self = this;
        requestAnimationFrame(function () { self.focusInitial(opts.focus); });
      }

      closeDrawer() {
        if (!this.isOpen) return;
        this.closeCalendar();
        this.teardownOpen();
        var target = this.opener;
        this.opener = null;
        if (!target || !target.isConnected || target.disabled || !isVisible(target)) {
          target = document.querySelector('[data-cart-drawer-open]');
        }
        if (target) target.focus({ preventScroll: true });
      }

      teardownOpen() {
        this.isOpen = false;
        this.removeAttribute('open');
        document.documentElement.classList.remove('cart-drawer-locked');
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('focusin', this.onFocusIn);
      }

      focusInitial(mode) {
        if (!this.isOpen) return;
        if (mode === 'scheduler') {
          var trigger = this.querySelector('[data-bqos-date-trigger]');
          if (isVisible(trigger)) {
            trigger.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
            trigger.focus({ preventScroll: true });
            return;
          }
        }
        this.titleEl.focus({ preventScroll: true });
      }

      calendarOpen() {
        var portal = document.querySelector('[data-bqos-cal-portal]');
        return !!(portal && !portal.hidden);
      }

      dateTrigger() {
        return this.querySelector('[data-bqos-date-trigger]');
      }

      closeCalendar() {
        var trigger = this.dateTrigger();
        if (this.calendarOpen() && trigger && trigger.getAttribute('aria-expanded') === 'true') trigger.click();
      }

      focusables() {
        return Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function (el) {
          return el.tabIndex >= 0 && !el.closest('[hidden]') && isVisible(el);
        });
      }

      onKeydown(e) {
        if (e.key === 'Escape') {
          if (e.target.closest && e.target.closest('.a11yw')) return;
          e.preventDefault();
          // Esc closes the innermost layer first: the date picker, then us.
          if (this.calendarOpen()) {
            var trigger = this.dateTrigger();
            this.closeCalendar();
            if (trigger) trigger.focus();
            return;
          }
          this.closeDrawer();
          return;
        }
        if (e.key !== 'Tab') return;
        var active = document.activeElement;
        // Into the portalled calendar from its trigger (it lives outside us).
        var trigger = this.dateTrigger();
        if (!e.shiftKey && active === trigger && this.calendarOpen()) {
          var first = document.querySelector('[data-bqos-cal-portal] button:not([disabled])');
          if (first) { e.preventDefault(); first.focus(); return; }
        }
        if (!this.panel.contains(active)) return; // onFocusIn handles escapes
        var items = this.focusables();
        if (!items.length) { e.preventDefault(); this.titleEl.focus(); return; }
        var head = items[0];
        var tail = items[items.length - 1];
        if (e.shiftKey && (active === head || active === this.titleEl)) {
          e.preventDefault();
          tail.focus();
        } else if (!e.shiftKey && active === tail) {
          e.preventDefault();
          head.focus();
        }
      }

      // Focus trap backstop: anything that lands focus outside the panel (a
      // click on the page behind, tabbing out of the calendar) comes back in.
      onFocusIn(e) {
        var t = e.target;
        if (t === document || t === window || this.panel.contains(t)) return;
        if (t.closest && t.closest(OUTSIDE_OK)) return;
        var from = e.relatedTarget;
        var trigger = this.dateTrigger();
        if (from && from.closest && from.closest('[data-bqos-cal-portal]') && isVisible(trigger)) {
          trigger.focus();
          return;
        }
        (this.focusables()[0] || this.titleEl).focus();
      }

      /* ---------- events inside the drawer ---------- */

      onClick(e) {
        var t = e.target;
        if (t.closest('[data-cart-drawer-close]')) {
          e.preventDefault();
          this.closeDrawer();
          return;
        }
        var delta = t.closest('[data-line-delta]');
        if (delta) {
          var line = delta.closest('[data-line-key]');
          this.changeLine(line.dataset.lineKey, { delta: Number(delta.dataset.lineDelta) });
          return;
        }
        var remove = t.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          this.changeLine(remove.closest('[data-line-key]').dataset.lineKey, { quantity: 0 });
          return;
        }
        var workshop = t.closest('[data-cart-drawer-workshop-checkout]');
        if (workshop && gated()) {
          e.preventDefault();
          return;
        }
        var link = t.closest('a[href]');
        if (link && link.target !== '_blank' && !e.metaKey && !e.ctrlKey && !e.shiftKey) this.navigating = true;
      }

      onChange(e) {
        var input = e.target.closest('[data-line-qty]');
        if (!input) return;
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        this.changeLine(input.closest('[data-line-key]').dataset.lineKey, { quantity: qty });
      }

      onSubmit() {
        // Checkout: leaving the page, so never reopen on the way back.
        this.navigating = true;
      }

      /* ---------- cart requests ---------- */

      setBusy(on) {
        var region = this.region();
        if (!region) return;
        if (on) region.setAttribute('aria-busy', 'true');
        else region.removeAttribute('aria-busy');
      }

      // `delta` is resolved when the request RUNS, against the quantity the
      // latest render shows, so two quick "+" taps add two, not one.
      changeLine(key, change) {
        var self = this;
        this.setBusy(true);
        return this.enqueue(function () {
          var quantity = change.quantity;
          if (change.delta) {
            var line = self.lineEl(key);
            if (!line) return null;
            quantity = Math.max(0, Number(line.dataset.lineQuantity) + change.delta);
          }
          return fetch(self.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: quantity,
              sections: self.sectionId,
              sections_url: window.location.pathname,
            }),
          })
            .then(readJSON)
            .then(function (data) {
              self.clearError();
              return self.renderFrom(data);
            })
            .then(function () { self.announce(self.dataset.msgUpdated); })
            .catch(function (err) {
              // e.g. 422 "only N left": say so, and show the real quantities.
              self.showError(err.message || self.dataset.msgError);
              return self.fetchSection().catch(function () {});
            });
        }).then(function () { self.setBusy(false); });
      }

      // Public: add a product form's contents (keeps selling_plan, properties
      // and everything else the form carries), re-render, open the drawer.
      addFromForm(form, opts) {
        opts = opts || {};
        var self = this;
        var submitter = opts.submitter || null;
        var errorEl = addErrorEl(form, submitter);
        errorEl.hidden = true;
        errorEl.textContent = '';
        var body = new FormData(form);
        body.append('sections', this.sectionId);
        body.append('sections_url', window.location.pathname);
        if (submitter) {
          submitter.disabled = true;
          submitter.setAttribute('aria-busy', 'true');
        }
        return this.enqueue(function () {
          return fetch(self.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: body,
          })
            .then(readJSON)
            .then(function (data) { return self.renderFrom(data); })
            .then(function () {
              self.clearError();
              self.openDrawer(submitter, { focus: opts.focusScheduler ? 'scheduler' : 'title' });
              self.announce(self.dataset.msgAdded);
            })
            .catch(function (err) {
              // Sold out, quantity limit, network: stay on the product, say why.
              errorEl.hidden = false;
              errorEl.textContent = err.message || self.dataset.msgAddError;
            });
        }).then(function () {
          if (!submitter) return;
          submitter.removeAttribute('aria-busy');
          submitter.disabled = gated();
        });
      }

      // Public: re-render from the server (e.g. after bqos:cart-changed).
      refresh() {
        var self = this;
        return this.enqueue(function () {
          return self.fetchSection().catch(function () {});
        });
      }

      // NOT queued — called from inside queued work.
      fetchSection() {
        var self = this;
        var root = this.dataset.rootUrl || '/';
        return fetch(root + (root.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(this.sectionId), {
          headers: { Accept: 'application/json' },
        })
          .then(readJSON)
          .then(function (data) { self.render(data[self.sectionId]); });
      }

      renderFrom(data) {
        var html = data && data.sections && data.sections[this.sectionId];
        if (html) {
          this.render(html);
          return Promise.resolve();
        }
        return this.fetchSection();
      }

      lineEl(key) {
        var lines = this.querySelectorAll('[data-line-key]');
        for (var i = 0; i < lines.length; i++) if (lines[i].dataset.lineKey === key) return lines[i];
        return null;
      }

      // Swap ONLY the lines/subtotal region. The checkout form (and the
      // scheduler mounted in it) is outside and is never touched.
      render(html) {
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-region]');
        var current = this.region();
        if (!fresh || !current) return;

        var memo = null;
        var active = document.activeElement;
        if (active && current.contains(active)) {
          var line = active.closest('[data-line-key]');
          memo = { key: line && line.dataset.lineKey, focusId: active.dataset.focusId };
        }

        fresh = document.adoptNode(fresh);
        current.replaceWith(fresh);
        this.sync(fresh);

        if (memo && this.isOpen) {
          var target = null;
          var freshLine = memo.key && this.lineEl(memo.key);
          if (freshLine && memo.focusId) target = freshLine.querySelector('[data-focus-id="' + memo.focusId + '"]');
          (target || this.titleEl).focus({ preventScroll: true });
        }
      }

      // Everything that depends on the cart but lives outside the region.
      sync(region) {
        if (!region) return;
        var count = parseInt(region.dataset.itemCount, 10) || 0;
        var form = this.querySelector('[data-cart-drawer-checkout]');
        if (form) form.hidden = region.dataset.checkout !== 'scheduler';
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.hidden = count === 0;
        });
        var label = region.dataset.cartLabel;
        if (label) {
          document.querySelectorAll('[data-cart-drawer-open]').forEach(function (el) {
            el.setAttribute('aria-label', label);
          });
        }
      }

      announce(msg) {
        var status = this.querySelector('[data-cart-drawer-status]');
        if (!status || !msg) return;
        status.textContent = '';
        setTimeout(function () { status.textContent = msg; }, 50);
      }

      showError(msg) {
        var el = this.querySelector('[data-cart-drawer-error]');
        if (!el) return;
        el.hidden = false;
        el.textContent = msg || this.dataset.msgError;
      }

      clearError() {
        var el = this.querySelector('[data-cart-drawer-error]');
        if (el) { el.hidden = true; el.textContent = ''; }
      }

      /* ---------- reload fallback ---------- */

      scrollPos() {
        return this.body ? this.body.scrollTop : 0;
      }

      restoreAfterReload() {
        var raw = null;
        try {
          raw = sessionStorage.getItem(RESTORE_KEY);
          sessionStorage.removeItem(RESTORE_KEY);
        } catch (e) { return; }
        if (!raw) return;
        var saved;
        try { saved = JSON.parse(raw); } catch (e) { return; }
        if (!saved || saved.path !== window.location.pathname || Date.now() - saved.t > RESTORE_MAX_AGE_MS) return;
        var self = this;
        this.classList.add('cart-drawer--instant');
        this.openDrawer(null, { focus: 'title' });
        var apply = function () { if (self.body && saved.scroll) self.body.scrollTop = saved.scroll; };
        requestAnimationFrame(function () {
          apply();
          requestAnimationFrame(function () { self.classList.remove('cart-drawer--instant'); });
        });
        // The scheduler mounts on DOMContentLoaded and fills in from the cart;
        // re-apply once the page has settled so the scroll lands on it.
        window.addEventListener('load', function () { setTimeout(apply, 100); }, { once: true });
      }
    }

    if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

    function drawerEl() {
      var d = document.querySelector('cart-drawer');
      return d && typeof d.openDrawer === 'function' ? d : null;
    }

    // Error line for an add-to-cart form: the form's own [data-cart-add-error]
    // if it has one, else one created right after the button.
    function addErrorEl(form, submitter) {
      var el = form.querySelector('[data-cart-add-error]');
      if (el) return el;
      el = document.createElement('p');
      el.className = 'cart-add-error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-cart-add-error', '');
      el.hidden = true;
      if (submitter && form.contains(submitter)) submitter.insertAdjacentElement('afterend', el);
      else form.appendChild(el);
      return el;
    }

    // Header cart icon (and any other [data-cart-drawer-open]): open instead
    // of navigating. Without the drawer on the page the link just works.
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var opener = e.target.closest && e.target.closest('[data-cart-drawer-open]');
      if (!opener) return;
      var d = drawerEl();
      if (!d) return;
      e.preventDefault();
      d.openDrawer(opener);
    });

    // Add-to-cart forms marked [data-cart-drawer-add] (product, subscription).
    // With no JS, or no drawer, they post to /cart/add as before.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-cart-drawer-add]')) return;
      var d = drawerEl();
      if (!d) return;
      e.preventDefault();
      if (gated()) return;
      d.addFromForm(form, { submitter: e.submitter || form.querySelector('[type="submit"]') });
    });

    // BouquetOS scheduler: a fee line changed. While the drawer is open,
    // cancel its page reload and re-render just the lines/subtotal. Closed
    // (or on /cart, where there is no drawer), let it reload as designed.
    document.addEventListener('bqos:cart-changed', function (e) {
      var d = drawerEl();
      if (!d || !d.isOpen) return;
      e.preventDefault();
      d.refresh();
    });

    // Reload fallback for schedulers that predate bqos:cart-changed (and the
    // legacy-fee purge): if the page goes away with the drawer open and comes
    // back to the SAME path within seconds, reopen it. Following a link or
    // submitting checkout from the drawer sets `navigating`, so never reopens.
    window.addEventListener('pagehide', function () {
      var d = drawerEl();
      if (!d || !d.isOpen || d.navigating) return;
      try {
        sessionStorage.setItem(RESTORE_KEY, JSON.stringify({ path: window.location.pathname, t: Date.now(), scroll: d.scrollPos() }));
      } catch (err) { /* storage unavailable: just don't reopen */ }
    });

    // Back/forward cache: the page comes back exactly as left, but the cart
    // may have changed meanwhile (checkout, another tab).
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      try { sessionStorage.removeItem(RESTORE_KEY); } catch (err) {}
      var d = drawerEl();
      if (d) { d.navigating = false; d.refresh(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var cartForm = document.getElementById('cart-form');
    if (!cartForm) return;

    // Quantity buttons
    cartForm.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('input');
        if (this.dataset.action === 'decrease') {
          if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
        } else {
          input.value = parseInt(input.value) + 1;
        }
        cartForm.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var searchInput = document.getElementById('collection-search');
    if (!searchInput) return;

    var cards = document.querySelectorAll('.product-card');
    var countEl = document.getElementById('collection-count');
    var totalCount = cards.length;

    searchInput.addEventListener('input', function() {
      var query = this.value.toLowerCase().trim();
      var visible = 0;

      cards.forEach(function(card) {
        var title = (card.dataset.productTitle || '').toLowerCase();
        if (!query || title.indexOf(query) !== -1) {
          card.style.display = '';
          visible++;
        } else {
          card.style.display = 'none';
        }
      });

      if (countEl) {
        countEl.textContent = visible + ' products';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-workshop"]) return;
  try {
    
  (function() {
    var variantSelect = document.getElementById('workshop-variant-id');
    var submitBtn = document.getElementById('workshop-submit');
    var priceEl = document.querySelector('.workshop-product__price');
    var comparePriceEl = document.querySelector('.workshop-product__compare-price');
    var mainImg = document.getElementById('workshop-main-img');

    if (!variantSelect) return;

    function getSelectedOptions() {
      var options = [];
      document.querySelectorAll('.workshop-product__option').forEach(function(wrapper) {
        var btnGroup = wrapper.querySelector('.workshop-product__option-btns');
        if (btnGroup) {
          var active = btnGroup.querySelector('.workshop-product__option-btn--active');
          if (active) options.push(active.dataset.value);
        } else {
          var sel = wrapper.querySelector('.workshop-product__select');
          if (sel) options.push(sel.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variantSelect.options.length; i++) {
        var opt = variantSelect.options[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          var optionValue = opt.dataset['option' + (j + 1)];
          if (!optionValue || optionValue !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return opt;
      }
      return null;
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variantOpt = findVariant(options);
      if (!variantOpt) return;

      variantSelect.value = variantOpt.value;

      if (priceEl) priceEl.textContent = variantOpt.dataset.price;
      var compareRaw = parseInt(variantOpt.dataset.comparePriceRaw);
      var priceRaw = parseInt(variantOpt.dataset.priceRaw);
      if (comparePriceEl) {
        if (compareRaw > priceRaw) {
          priceEl.classList.add('workshop-product__price--sale');
          comparePriceEl.textContent = variantOpt.dataset.comparePrice;
          comparePriceEl.style.display = '';
        } else {
          priceEl.classList.remove('workshop-product__price--sale');
          comparePriceEl.style.display = 'none';
        }
      }

      var available = variantOpt.dataset.available === 'true';
      // Keep the button off while the BouquetOS checkout gate has paused ordering.
      submitBtn.disabled = !available || document.body.classList.contains('bqos-gate-on');
      submitBtn.textContent = available ? submitBtn.dataset.addText : submitBtn.dataset.soldText;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantOpt.value);
      window.history.replaceState({}, '', url.toString());
    }

    // Event delegation for option buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.workshop-product__option-btn');
      if (!btn) return;
      var group = btn.closest('.workshop-product__option-btns');
      if (!group) return;
      group.querySelectorAll('.workshop-product__option-btn').forEach(function(b) {
        b.classList.remove('workshop-product__option-btn--active');
      });
      btn.classList.add('workshop-product__option-btn--active');
      updateVariant();
    });

    // Event delegation for option selects
    document.addEventListener('change', function(e) {
      if (e.target.matches('.workshop-product__select')) {
        updateVariant();
      }
    });

    // Thumbnail clicks
    var activeThumb = document.querySelector('.workshop-product__thumb--active');
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.workshop-product__thumb');
      if (!thumb) return;
      if (thumb === activeThumb) return;
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
      mainImg.sizes = '(max-width: 768px) 100vw, 50vw';
      if (activeThumb) activeThumb.classList.remove('workshop-product__thumb--active');
      thumb.classList.add('workshop-product__thumb--active');
      activeThumb = thumb;
    });

    // Form validation + skip cart, go straight to checkout
    document.getElementById('workshop-form').addEventListener('submit', function(e) {
      e.preventDefault();
      var form = this;
      var required = form.querySelectorAll('[required]');
      var missing = [];
      required.forEach(function(el) {
        if (!el.value.trim()) missing.push(el);
      });
      if (missing.length > 0) {
        missing[0].focus();
        missing.forEach(function(el) {
          el.classList.add('workshop-form__input--error');
          setTimeout(function() { el.classList.remove('workshop-form__input--error'); }, 3000);
        });
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      var formData = new FormData(form);
      var properties = {};
      formData.forEach(function(value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });

      var variantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity')) || 1;

      // Clear cart, add just this workshop item, then go to checkout
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: quantity, properties: properties })
        });
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.addText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var variantSelect = document.getElementById('product-variant-id');
    var addBtn = document.getElementById('product-add-btn');
    var buyNowBtn = document.getElementById('product-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        if (buyNowBtn.disabled || document.body.classList.contains('bqos-gate-on')) return;
        var form = document.getElementById('product-form');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.addFromForm === 'function') {
          drawer.addFromForm(form, { submitter: buyNowBtn, focusScheduler: true });
          return;
        }
        // No drawer on this page: add, then the cart page.
        buyNowBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function(r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
          .catch(function() { buyNowBtn.disabled = false; });
      });
    }
    var priceEl = document.getElementById('product-price');
    var comparePriceEl = document.getElementById('product-compare-price');
    var saleBadge = document.getElementById('product-sale-badge');
    var mainImg = document.getElementById('product-main-img');

    if (!variantSelect) return;

    function getSelectedOptions() {
      var options = [];
      document.querySelectorAll('.product-page__option').forEach(function(wrapper) {
        var btnGroup = wrapper.querySelector('.product-page__option-btns');
        if (btnGroup) {
          var active = btnGroup.querySelector('.product-page__option-btn--active');
          if (active) options.push(active.dataset.value);
        } else {
          var sel = wrapper.querySelector('.product-page__option-select');
          if (sel) options.push(sel.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variantSelect.options.length; i++) {
        var opt = variantSelect.options[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          var optionValue = opt.dataset['option' + (j + 1)];
          if (!optionValue || optionValue !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return opt;
      }
      return null;
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variantOpt = findVariant(options);
      if (!variantOpt) return;

      variantSelect.value = variantOpt.value;

      var startingFrom = document.querySelector('.product-page__starting-from');
      if (startingFrom) startingFrom.style.display = 'none';

      priceEl.textContent = variantOpt.dataset.price;
      var compareRaw = parseInt(variantOpt.dataset.comparePriceRaw);
      var priceRaw = parseInt(variantOpt.dataset.priceRaw);
      if (compareRaw > priceRaw) {
        priceEl.classList.add('product-page__price--sale');
        comparePriceEl.textContent = variantOpt.dataset.comparePrice;
        comparePriceEl.style.display = '';
        saleBadge.style.display = '';
      } else {
        priceEl.classList.remove('product-page__price--sale');
        comparePriceEl.style.display = 'none';
        saleBadge.style.display = 'none';
      }

      var available = variantOpt.dataset.available === 'true';
      if (addBtn) {
        // Keep the button off while the BouquetOS checkout gate has paused ordering.
        addBtn.disabled = !available || document.body.classList.contains('bqos-gate-on');
        addBtn.textContent = available ? addBtn.dataset.addText || 'Add to Cart' : addBtn.dataset.soldText || 'Sold Out';
      }
      if (buyNowBtn) buyNowBtn.disabled = !available || document.body.classList.contains('bqos-gate-on');

      var imageId = variantOpt.dataset.imageId;
      if (imageId && mainImg) {
        document.querySelectorAll('.product-page__thumb').forEach(function(thumb) {
          if (thumb.dataset.imageId === imageId) {
            switchToThumb(thumb);
          }
        });
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantOpt.value);
      window.history.replaceState({}, '', url.toString());
    }

    // Event delegation for option buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-page__option-btn');
      if (!btn) return;
      var group = btn.closest('.product-page__option-btns');
      if (!group) return;
      group.querySelectorAll('.product-page__option-btn').forEach(function(b) {
        b.classList.remove('product-page__option-btn--active');
      });
      btn.classList.add('product-page__option-btn--active');
      updateVariant();
    });

    // Event delegation for option selects
    document.addEventListener('change', function(e) {
      if (e.target.matches('.product-page__option-select')) {
        updateVariant();
      }
    });

    // Thumbnail clicks
    var activeThumb = document.querySelector('.product-page__thumb--active');
    function switchToThumb(thumb) {
      if (thumb === activeThumb) return;
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
      mainImg.sizes = '(max-width: 768px) 100vw, 50vw';
      if (activeThumb) activeThumb.classList.remove('product-page__thumb--active');
      thumb.classList.add('product-page__thumb--active');
      activeThumb = thumb;
    }
    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.product-page__thumb');
      if (thumb) switchToThumb(thumb);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var input = document.getElementById('search-input');
    var clearBtn = document.getElementById('search-clear');
    var predictiveWrap = document.getElementById('predictive-search');
    var predictiveResults = document.getElementById('predictive-results');
    var predictiveLoading = document.getElementById('predictive-loading');
    var debounceTimer = null;
    var abortController = null;

    if (!input) return;

    function toggleClear() {
      clearBtn.style.display = input.value.length > 0 ? '' : 'none';
    }

    clearBtn.addEventListener('click', function() {
      input.value = '';
      input.focus();
      toggleClear();
      hidePredictive();
    });

    function hidePredictive() {
      predictiveWrap.style.display = 'none';
      predictiveResults.innerHTML = '';
    }

    function showLoading() {
      predictiveWrap.style.display = '';
      predictiveLoading.style.display = '';
      predictiveResults.innerHTML = '';
    }

    function fetchPredictive(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      showLoading();

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6', {
        signal: abortController.signal
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        predictiveLoading.style.display = 'none';
        var resources = data.resources && data.resources.results;
        if (!resources) { hidePredictive(); return; }

        var html = '';
        var groups = ['products', 'articles', 'pages'];
        var hasResults = false;

        groups.forEach(function(group) {
          var items = resources[group];
          if (!items || items.length === 0) return;
          hasResults = true;

          items.forEach(function(item) {
            var imgHtml = '';
            if (item.image || item.featured_image) {
              var imgSrc = (item.featured_image && item.featured_image.url) || item.image;
              imgHtml = '<img src="' + imgSrc + '&width=120&height=120&crop=center" alt="" loading="lazy">';
            } else {
              imgHtml = '<span class="predictive-search__no-img"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></span>';
            }

            var priceHtml = '';
            if (item.price) {
              priceHtml = '<span class="predictive-search__price">' + item.price + '</span>';
            }

            html += '<a href="' + item.url + '" class="predictive-search__item">'
              + '<div class="predictive-search__item-img">' + imgHtml + '</div>'
              + '<div class="predictive-search__item-info">'
              + '<span class="predictive-search__item-title">' + item.title + '</span>'
              + priceHtml
              + '</div>'
              + '</a>';
          });
        });

        if (!hasResults) {
          hidePredictive();
          return;
        }

        html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">'
          + 'View all results <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
          + '</a>';

        predictiveResults.innerHTML = html;
      })
      .catch(function(err) {
        if (err.name !== 'AbortError') hidePredictive();
      });
    }

    input.addEventListener('input', function() {
      toggleClear();
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        hidePredictive();
        return;
      }
      debounceTimer = setTimeout(function() {
        fetchPredictive(q);
      }, 300);
    });

    document.addEventListener('click', function(e) {
      if (!predictiveWrap.contains(e.target) && e.target !== input) {
        hidePredictive();
      }
    });

    input.addEventListener('focus', function() {
      if (input.value.trim().length >= 2 && predictiveResults.innerHTML) {
        predictiveWrap.style.display = '';
      }
    });

    toggleClear();
  })();

  } catch(e) { console.error(e); }
})();
})();
